"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.landingPageReferrers = void 0;
exports.landingPageReferrers = {
    avencb: 'avencb',
};
